import React from 'react'
import { Helmet } from 'react-helmet-async'
import { BillingAlertsLayout } from '../../layouts/Billing'

const BillingAlertsPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Billing Alerts</title>
      <meta name="description" content="Billing Details page" />
    </Helmet>
    <BillingAlertsLayout />
  </React.Fragment>
)

export default BillingAlertsPage
